import Cookies from 'universal-cookie'
import * as config from './Config.js'

const profile = {
    is_loaded: false,
    user_id: '',
    first_name: '',
    customer_id: '',
    email_address: '',
    default_page: '',
    is_acumen_admin: false,
    is_customer_admin: false,
    show_custom_workspace: false
}

class UserProfile { 
    itemName = 'profile'
    loadData(token, afterFunc = null) {
        if (profile.is_loaded) {
            if (afterFunc != null){
                afterFunc();
            }

            return;
        }

        //var c = new Cookies();
        //const p = c.get(this.itemName);
        var p;
        if (p === undefined) {
            this.fetchData(token, afterFunc);
            return;
        }

        //console.log(p);
        // this.fillState(JSON.parse(p), afterFunc);
        this.fillState(p, afterFunc);
    }
    signout() {
        profile.user_id = '';
        profile.is_acumen_admin = false;
        profile.is_customer_admin = false;
        profile.first_name = '';
        profile.customer_id = '';
        profile.email_address = '';
        profile.default_page = '';
        profile.is_loaded = false;
        profile.show_custom_workspace = false;

        var c = new Cookies();
        c.remove(this.itemName);
        sessionStorage.clear();
    }
    fillState(p, afterFunc) {
        //if (p === undefined) {
        //    this.fetchData(null, afterFunc);
        //    return;
        //}
        profile.user_id = p.user_id;
        profile.is_acumen_admin = p.is_acumen_admin;
        profile.is_customer_admin = p.is_customer_admin;
        profile.first_name = p.first_name;
        profile.email_address = p.email_address;
        profile.customer_id = p.customer_id;
        profile.default_page = p.user_default_link;
        profile.show_custom_workspace = p.show_custom_workspace;
        // console.log(p)
        profile.is_loaded = true;
        if (afterFunc != null){
            afterFunc();
        }
}
    fetchData(token, afterFunc) {
        var that = this;
        var t = token;
        if (t === null) {
            // console.log('get t');
            t = config.AuthManager.getToken();
            //console.log(t);
        }

        let uri = config.getAcumenAPIURL('api/user/profile');        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix());
        myHeaders.append("tkn", t);

        //console.log(config.ApiHeaders())
        //const uri = config.getUriPath('users/profile')
        fetch(uri, {
            method: 'get',
            headers: myHeaders
           }).then(function(response) {

            if (response.status >= 400) {
              ///throw new Error("Bad response from server");
              console.log('fetchData UP: ' + response.status);
            }

            if (response.status >= 204) {
                return null;
            }

            return response.json();
          })
          .then(function(data) {
            if (data == null) {
                return;
            }

            var c = new Cookies();
            c.set(that.itemName, JSON.stringify(data));
            const p = c.get(that.itemName);
            //console.log(p.user_id);
            that.fillState(p, afterFunc);
        });
    }
    IsAcumenAdmin = () => {
        return profile.is_acumen_admin;
    }
    IsCustomerAdmin() {
        return profile.is_customer_admin;
    }
    FirstName() {
        return profile.first_name;
    }
    CustomerId() {
        return profile.customer_id;
    }
    UserId() {
        return profile.user_id;
    }
    Email() {
        return profile.email_address;
    }
    DefaultPage() {
        return profile.default_page;
    }
    ShowCustomWorkspace()
    {
        return profile.show_custom_workspace;
    }
}

export default UserProfile


// WEBPACK FOOTER //
// ./src/Components/Configuration/UserProfile.js